import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import useFlash from "go-alert/AlertMessage";
import Header from "go-app/components/Header";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import { adminApi } from "../../../../../../../../services/Api/Admin/adminApi";
import { ProductPackageApi } from "../../../../services/types";
import { ProductPackagesForm } from "../../components/ProductPackagesForm";

interface MatchParams {
	productPackageId: string;
}

export const ProductPackagesEditPage = () => {
	const [productPackage, setProductPackage] = useState<ProductPackageApi | undefined>(undefined);
	const { productPackageId } = useParams<MatchParams>();
	const { t } = useTranslation();
	const { addFlash } = useFlash();
	const { handleChangeTabTitle } = useBrowserTabTitle();

	useEffect(() => {
		fetchProductPackage();
	}, []);

	const fetchProductPackage = async () => {
		try {
			const params = { include: "barcodes" };
			const res = await adminApi.getProductPackage(productPackageId, params);
			setProductPackage(res);
			handleChangeTabTitle(`${res.name} | ${t("modules.product_package.header.title")}`);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	if (!productPackage) return <LoadingContainer />;

	return (
		<>
			<Header title={`${t("modules.product_package.header.title")} "${productPackage.name}"`} />
			<ProductPackagesForm productPackage={productPackage} />
		</>
	);
};
